module.exports = __webpack_public_path__ + "static/media/PYP-page.bffe327e.png";